import React, { useEffect, useRef, useState } from 'react';

export default function CountUp({ target, suffix = '', decimals = 0, duration = 1800, decimalSeparator = '.' }) {
  const [value, setValue] = useState(0);
  const startedRef = useRef(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !startedRef.current) {
          startedRef.current = true;
          const startTime = performance.now();
          const animate = (now) => {
            const progress = Math.min((now - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setValue(target * eased);
            if (progress < 1) requestAnimationFrame(animate);
            else setValue(target);
          };
          requestAnimationFrame(animate);
          io.unobserve(el);
        }
      });
    }, { threshold: 0.3 });
    io.observe(el);
    return () => io.disconnect();
  }, [target, duration]);

  const display = decimals > 0
    ? value.toFixed(decimals).replace('.', decimalSeparator)
    : Math.round(value).toString();

  return <span ref={ref} data-testid="count-up-value">{display}{suffix}</span>;
}
